import Qs from 'qs'
import omit from 'lodash/omit'
import { FooterRecommentTipTypeEnum, SelectWfgDemandEnum } from '../../constants/newlywedZone'
import { DefaultQueryProps } from '@/modules/globals/hooks/usePageQuery'
import { ViewType } from '@/modules/partnership/constants/viewType'
import { handleLocationUrl } from '@/modules/partnership/utils/handleLocationUrl/handleLocationUrl'
import { commonHistoryPush } from '@/modules/order/helper'
import { getTerminaDomain } from '@/utils/utils'
import { FIND_SUPPLIER_SUP_ENUM } from '@/modules/distribute/constants/distributionStation'

/**
 * 行为参数
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ActionQueryProps extends DefaultQueryProps {
    /** 视图类型 */
    vt: ViewType
}

export const actionQuery: (keyof ActionQueryProps)[] = []

/**
 * 查询参数
 */

export interface QueryProps extends ActionQueryProps {
    /**
     * @description       邀约参数 要筛选出商品
     */
    paramId?: string
    /**
     * @description       一级类目
     */
    mainCategoryIds?: string
    /**
     * @description       二级类目
     */
    categoryIds?: string
    /**
     * @description       三级类目
     */
    thirdCategoryIds?: string
    /** 从找供应商榜单跳入的类型  */
    sortType?: FIND_SUPPLIER_SUP_ENUM.TOP_CREATED | FIND_SUPPLIER_SUP_ENUM.TOP_SALE
    /** 商品名称 */
    goodsName?: string
    /**
     * @description       好货推荐标
     */
    freshmanLabels?:
        | FooterRecommentTipTypeEnum.bestSellingYesterday
        | FooterRecommentTipTypeEnum.trendNew
        | FooterRecommentTipTypeEnum.trendChart
    /**
     * @description       是否选中找货需求 如果有一级二级三级类目,这个就是不选中
     */
    selectWfgDemand?: SelectWfgDemandEnum.noSelect | SelectWfgDemandEnum.select
}

/**
 *   @description 去爆款专区
 *  默认情况有参数，就不选中找货需求
 *  特殊逻辑！！！首页是带参数，也要选中找货需求
 */

export const goToNewlywedZone = (
    query?: QueryProps & {
        /**
         * @description       是否需要新开浏览器页面
         */
        _blank?: boolean
        /**
         * @description       是否需要加域名
         */
        needDomain?: boolean
    }
) => {
    const queryObj = omit(query || {}, ['_blank', 'needDomain'])
    const locationQuery = handleLocationUrl()
    const paramsStr = Qs.stringify({ ...queryObj, ...locationQuery }, { addQueryPrefix: true })
    const domain = window.MASTER_IS_CHANNEL
        ? getTerminaDomain(PROJECT_CONFIG.channelTerminalName)
        : getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)
    const domainStr = query?.needDomain ? domain : ''
    const url = window.MASTER_IS_CHANNEL
        ? `${domainStr}/channel/my/findCooperation/newlywedZone${paramsStr}`
        : `${domainStr}/findCooperation/newlywedZone${paramsStr}`
    if (query?._blank) {
        window.open(url, '_blank')
    } else {
        commonHistoryPush(url)
    }
}
